var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CommunicationNetworkGraphTeamPersonExternalMeetLinkInspectorContent } from '@web/components/CommunicationNetworkGraph/components/CommunicationNetworkGraphTeamPersonExternalMeetLinkInspectorContent';
/** CARD-48 — selected employee ↔ External (Meet). */
export var CommunicationNetworkGraphEmployeeScopePersonExternalMeetLinkInspectorContent = function (props) { return (_jsx(CommunicationNetworkGraphTeamPersonExternalMeetLinkInspectorContent, __assign({}, props))); };
